import { Dispatch } from 'redux';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';
import CrudActionContainer from './CrudActionContainer';
import LeadAssignmentsController from '../controllers/LeadAssignmentsController';
import { LeadAssignmentGroup } from '../interfaces/leadAssignmentGroups';
import { getActionHookBuilder } from './action-hook-builder';

class LeadAssignmentGroupsCRUDActions extends CrudActionContainer {
  resetAction: string;

  constructor() {
    super('LEAD_ASSIGNMENT_GROUPS');
    this.resetAction = super.makeActionKey('RESET');
  }

  create(botId: number, params: Partial<LeadAssignmentGroup>) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.createAction));
      try {
        const response = await LeadAssignmentsController.createAgentGroups(
          botId,
          params,
        );
        dispatch(leadAssignmentGroupsCRUDActions.retrieveAll(botId));

        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  update(botId: number, groupId: number, params: Partial<LeadAssignmentGroup>) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.updateAction));

      try {
        const response = await LeadAssignmentsController.updateAgentGroups(
          botId,
          groupId,
          params,
        );
        dispatch(leadAssignmentGroupsCRUDActions.retrieveAll(botId));
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  delete(botId: number, groupId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.deleteAction));
      try {
        const response = await LeadAssignmentsController.deleteAgentGroups(
          botId,
          groupId,
        );
        dispatch(leadAssignmentGroupsCRUDActions.retrieveAll(botId));
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  retrieveAll(botId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));
      try {
        const response = await LeadAssignmentsController.getAgentGroups(botId);
        const { leadAssignmentGroups } = response;
        dispatch(this.retrievedAll(leadAssignmentGroups));
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  reset() {
    return {
      type: this.resetAction,
    };
  }
}

const leadAssignmentGroupsCRUDActions = new LeadAssignmentGroupsCRUDActions();

export const useLeadAssignmentGroupsCRUDActions = getActionHookBuilder(
  leadAssignmentGroupsCRUDActions,
  ['reset', 'retrieveAll', 'create', 'update', 'delete'],
);

export default leadAssignmentGroupsCRUDActions;
